// Ir agregando paises a medida que sean necesarios
// eslint-disable-next-line no-shadow
export enum CountryISO {
  Chile = 'CL',
  Peru = 'PE',
  Brazil = 'BR',
  Mexico = 'MX',
  Otro = '-',
}
